import React from 'react'
import PropTypes from 'prop-types'

const Asterisk = ({ variant = 'primary' }) => (
  <span className={`fa-solid fa-asterisk text-${variant} fs-8 mx-1`} />
)

Asterisk.propTypes = {
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
    undefined // Allow variant to be undefined (optional prop)
  ])
}

export default Asterisk
